
<!--<section id="paging" class="mb-3">

  <div class="row">
    <div class="col-sm-12">
      <data-grid *ngIf="CurrentActorDocRenewAlertsInfoController"
                 [columns]="columns" [data]="CurrentActorDocRenewAlertsInfoController"
                 [gridbtns]="gridbtns"
                 [hdrbtns]="hdrbtns"
                 [sort]="sorting"
                 (btnclick)="gridaction($event)">
      </data-grid>

    </div>
  </div>
</section>-->
<div class="row margin-left-zero margin-right-0px" *ngIf="CurrentActorDocRenewAlertsInfoController" >
<div class="card  col-md-12 margin-lr-auto" *ngFor="let l of CurrentActorDocRenewAlertsInfoController;let RowIndex = index">
              <div class="card-body padding-lr-0px padding-top-7px padding-bottom">
                <div class="card">
                  <div [id]="'accordion'+RowIndex">
                    <div class="card-header padding-header card-header3" [id]="'heading'+RowIndex">
                      <div class="mb-0">
                        <div class="btn  col-md-12" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                             aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                          <div class="row">
                            <div class="col-md-7 padding-lr-0px text-left">
                              <label class="normal-small-text">{{l.CredentialTypeName}}</label>
                            </div>
                            <div class="col-md-5 padding-lr-0px text-align-right">
                              <label class="normal-small-text contracts-badge3 bg-danger" *ngIf="l.AlertLevel=='Critical'">{{l.AlertLevel}}</label>
                              <label class="normal-small-text contracts-badge3 bg-primary" *ngIf="l.AlertLevel!='Critical'">{{l.AlertLevel}}</label>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                         [attr.data-parent]="'#accordion'+RowIndex">

                      <div class="card-body padding-tb background-pay card-body-crend">
                        <div class="row row-margin-zero">
                          <div class="col-md-12 col-xs-4 col-4 padding-lr-0px">

                            <label class="normal-small-text text8">
                             Issued by: {{l.IssuingAuthority}}
                            </label>
                          </div>
                        </div>
                        <div class="row row-margin-zero">
                          <div class="col-md-12 col-xs-4 col-4 padding-lr-0px">

                            <label class="normal-small-text text8">
                              {{l.ValidFrom | date:'MM-dd-yyyy'}} to {{l.ValidTo |date:'MM-dd-yyyy'}}
                             
                            </label>
                          </div>
                        </div>
                        <div class="row row-margin-zero">
                          <div class="col-md-12 col-xs-4 col-4 padding-lr-0px">

                            <label class="normal-small-text text8 text-danger">
                              <i class="fa fa-unlock"></i> {{l.DocRenewMessage}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          

       

      
  
</div>
